module.exports = __webpack_public_path__ + "01_mole.7178349a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/01_mole.png
// module id = SPKB
// module chunks = 0